import { CountResponse, WalletWithAccountId, createDeleteWalletMutation } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type DeleteWalletModel = ConfirmModalModel<WalletWithAccountId, number, CountResponse>;

export const createDeleteWalletModel = (): DeleteWalletModel => {
	const deleteWalletMutation = createDeleteWalletMutation();

	const model = createConfirmModalModel<WalletWithAccountId, number, CountResponse>({
		modalData: declareModalData<WalletWithAccountId>(),
		mapModalData: ({ id }) => id,
		mutation: deleteWalletMutation,
		successMessageKey: 'delete-wallet.success',
	});

	return model;
};
